import '@/assets/css/main.css';

import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';

import GlobalWebsiteApp from '@/apps/website/GlobalWebsiteApp.vue';

const globalApp = createApp(GlobalWebsiteApp);

const pinia = createPinia();

globalApp.use(pinia);

globalApp.mount('#globalWebsiteAppContainer');

const WebsiteSearchApp = defineAsyncComponent(() => import('@/apps/website/website-search/WebsiteSearchApp.vue'));

const TemperatureConversionCalculatorApp = defineAsyncComponent(() => import('@/apps/website/calculators/TemperatureConversionCalculatorApp.vue'));
const ThreePhaseUnitCalculatorApp = defineAsyncComponent(() => import('@/apps/website/calculators/ThreePhaseUnitCalculatorApp.vue'));
const SinglePhaseUnitCalculatorApp = defineAsyncComponent(() => import('@/apps/website/calculators/SinglePhaseUnitCalculatorApp.vue'));
const PowerFlowrateTempCalculatorApp = defineAsyncComponent(() => import('@/apps/website/calculators/PowerFlowrateTempCalculatorApp.vue'));
const OhmsLawCalculatorApp = defineAsyncComponent(() => import('@/apps/website/calculators/OhmsLawCalculatorApp.vue'));
const HeatTransferThroughConvectionCalculatorApp = defineAsyncComponent(
  () => import('@/apps/website/calculators/HeatTransferThroughConvectionCalculatorApp.vue')
);
const ACFMtoSCFMCalculatorApp = defineAsyncComponent(
  () => import('@/apps/website/calculators/ACFMtoSCFMCalculatorApp.vue')
);
const MassFlowToVolumetricFlowCalculatorApp = defineAsyncComponent(
  () => import('@/apps/website/calculators/MassFlowToVolumetricFlowCalculatorApp.vue')
);

const FarnamFlexSpecsApp = defineAsyncComponent(() => import('@/apps/website/farnam-custom/FlexSpecsApp.vue'));
const FarnamBuildYourOwnApp = defineAsyncComponent(() => import('@/apps/website/farnam-custom/BuildYourOwnApp.vue'));
const FarnamContactFormApp = defineAsyncComponent(() => import('@/apps/website/farnam-custom/ContactFormApp.vue'));
const FarnamDetermineYourHeaterApp = defineAsyncComponent(() => import('@/apps/website/farnam-custom/DetermineYourHeaterApp.vue'));
const FarnamPowerFlowRateApp = defineAsyncComponent(() => import('@/apps/website/farnam-custom/PowerFlowRateApp.vue'));

const constructorsApps = [
  {
    elementId: 'website-search',
    component: WebsiteSearchApp,
  },
  {
    elementId: 'temperature-conversion-calculator-app',
    component: TemperatureConversionCalculatorApp,
  },
  {
    elementId: 'three-phase-unit-calculator-app',
    component: ThreePhaseUnitCalculatorApp,
  },
  {
    elementId: 'single-phase-unit-calculator-app',
    component: SinglePhaseUnitCalculatorApp,
  },
  {
    elementId: 'power-flowrate-temp-calculator-app',
    component: PowerFlowrateTempCalculatorApp,
  },
  {
    elementId: 'ohms-law-calculator-app',
    component: OhmsLawCalculatorApp,
  },
  {
    elementId: 'heat-transfer-through-convection-calculator-app',
    component: HeatTransferThroughConvectionCalculatorApp,
  },
  {
    elementId: 'acfm-to-scfm-calculator-app',
    component: ACFMtoSCFMCalculatorApp,
  },
  {
    elementId: 'mass-flow-to-volumetric-flow-calculator-app',
    component: MassFlowToVolumetricFlowCalculatorApp,
  },
  {
    elementId: 'farnam-flex-specs-app',
    component: FarnamFlexSpecsApp,
  },
  {
    elementId: 'farnam-build-your-own-app',
    component: FarnamBuildYourOwnApp,
  },
  {
    elementId: 'farnam-contact-form-app',
    component: FarnamContactFormApp,
  },
  {
    elementId: 'determine-your-heater-app',
    component: FarnamDetermineYourHeaterApp,
  },
  {
    elementId: 'farnam-power-flow-rate-app',
    component: FarnamPowerFlowRateApp,
  },
];

const constructors = document.querySelectorAll('.complex_component');
constructors.forEach((element: HTMLElement) => {
  constructorsApps.forEach((app) => {
    if (element.dataset.component_id === app.elementId) {
      createApp(app.component).use(pinia).mount(`#${element.id}[data-component_id="${app.elementId}"]`);
    }
  });
});
